import PlayerDirective from './player.directive.js';
/**
 * @ngdoc module
 * @name Player Module
 * @description The player component.
 */
angular.module('app.player', ['app.services'])
  .directive('player', PlayerDirective);



/** WEBPACK FOOTER **
 ** ./src/app/components/player/player.module.js
 **/